export default "__VITE_ASSET__911191c3__"